const dd = require("./../default-engine/engine").default;

// Add processes to engine
dd.addProcesses(require("./../default-engine/basicValidators").default);
dd.addProcesses(require("./../default-engine/basicUpdaters").default);
dd.addProcesses(require("./../default-engine/basicTransformers").default);
dd.addProcesses(require("./../default-engine/otherUpdaters").default);
